import { Link } from "react-router-dom";
import "./DiscoveryCategoryTile.css";
import { imageProps, SIZES } from "../../utils/imageUrl";

/**
 * A category tile in the Discovery row — what fills a position when the
 * catalogue can't supply three eligible products.
 *
 * It is deliberately not a product card: full-bleed category artwork under
 * a scrim, a "Category" eyebrow and an "Explore <name>" line, with no
 * rating, review count, price or wishlist heart anywhere on it. Opening it
 * goes to that category's real page.
 *
 * The image is decorative (`alt=""`): the label beside it already names
 * the category, so a screen reader would otherwise hear it twice.
 */
const DiscoveryCategoryTile = ({ category }) => (
  <li className="dtile" data-testid="discovery-category-tile">
    <Link to={category.to} className="dtile-link" aria-label={`Explore ${category.name} category`}>
      <img className="dtile-img" {...imageProps(category.imageUrl, "tile", SIZES.tile)} alt="" loading="lazy" decoding="async" />
      <span className="dtile-body">
        <span className="dtile-eyebrow">Category</span>
        <span className="dtile-label">Explore {category.name}</span>
      </span>
    </Link>
  </li>
);

export default DiscoveryCategoryTile;
